const datas1 = [
    {
        id: 1,
        task: `25 gr natriy oksidiniń  (Na<sub>2</sub>O)  muǵdarin tabiń?`,
        desc: `Berilgen: Mr(Na<sub>2</sub>O) =2*23+16=62gr/mol`,
        desc2: 'm(Na<sub>2</sub>O) =25gr',
        a: `1mol`,
        b: `62gr`,
        c: `x`,
        d: `25`,
        x: `0,4mol`
    },
    {
        id: 2,
        task: `Massasi 12 gr bolǵan kúkirt (IV) oksidindegi zat muǵdarin tabiń?`,
        desc: `Berilgen:Mr(SO<sub>2</sub>)=32+16*2=64gr/mol`,
        desc2: 'm(SO<sub>2</sub>)=12gr',
        a: `1mol`,
        b: `64gr`,
        c: `x`,
        d: `12gr`,
        x: `0,187mol`
    },
    {
        id: 3,
        task: `Massasi 25,5gr bolǵan Al<sub>2</sub>O<sub>3</sub> muǵdarin  tabiń?`,
        desc: `Berilgen: Mr(Al<sub>2</sub>O<sub>3</sub>)=27*2+16*3=102gr/mol`,
        desc2: 'm(Al<sub>2</sub>O<sub>3</sub>)=25,5gr',
        a: `1mol`,
        b: `102gr`,
        c: `x`,
        d: `25.5gr`,
        x: `0.25mol`
    },
    {
        id: 4,
        task: `Muǵdari 0,25 mol bolǵan Fe<sub>2</sub>O<sub>3</sub> tiń massasin tabiń?`,
        desc: `Berilgen: Mr(Fe<sub>2</sub>O<sub>3</sub>)=56*2+16*3=160gr/mol`,
        desc2: 'n(Fe<sub>2</sub>O<sub>3</sub>)=0,25 mol',
        a: `1mol`,
        b: `160gr`,
        c: `0,25mol`,
        d: `x`,
        x: `40gr`
    }, {
        id: 5,
        task: `Muǵdari 0,6 mol bolǵan  azot (I) oksidiniń (N<sub>2</sub>O) massasin tabiń?`,
        desc: `Berilgen:Mr(N<sub>2</sub>O) =14*2+16=44gr/mol`,
        desc2: 'n(N<sub>2</sub>O)=0,6 mol',
        a: `1mol`,
        b: `44gr`,
        c: `0,6`,
        d: `x`,
        x: `26,4 gr`
    }, {
        id: 6,
        task: `Quraminda 0,8 mol atomliq kaliy bolǵan kaliy oksidiniń (K<sub>2</sub>O)  massasin tabiń?`,
        desc: `Berilgen:Mr(K<sub>2</sub>O)=39*2+16=94gr/mol`,
        desc2: 'n(K<sub>2</sub>O)=0,8 mol',
        e:'K<sub>2</sub>O oksidte 2 mol kaliy bar ekenligin esapqa alamiz',
        a: `94gr`,
        b: `2mol(K)`,
        c: `x`,
        d: `0,8mol`,
        x: `37,6gr`
    }, {
        id: 7,
        task: `Quraminda 1,6 mol atomliq kislorod bolǵan kremniy oksidiniń (SiO<sub>2</sub>)muǵdarin tabiń?`,
        desc: `Berilgen: Mr(SiO<sub>2</sub>)=28+16*2=60gr/mol`,
        desc2: 'n((SiO<sub>2</sub>)=1,6 mol',
        a: `1mol`,
        b: `2mol`,
        c: `x`,
        d: `1,6mol`,
        e:'SiO<sub>2</sub> te 2 mol kislorod bar ekenligin esapqa alamiz',
        x: `0,8 mol`
    }, {
        id: 8,
        task: `Muǵdari 1,8 mol bolǵan bor oksidiniń (B<sub>2</sub>O<sub>3</sub>) massasin tabiń?`,
        desc: `Berilgen:Mr(B<sub>2</sub>O<sub>3</sub>)=11*2+16*3=70gr/mol`,
        desc2: 'n(B<sub>2</sub>O<sub>3</sub>)=1,8 mol',
        a: `1mol`,
        b: `70gr`,
        c: `1,8mol`,
        d: `x`,
        x: `126gr`
    }, {
        id: 9,
        task: `Massasi 25 gr bolǵan Cr<sub>2</sub>O<sub>3</sub> tegi Cr  atomlariniń sanin esaplań?`,
        desc: `Berilgen:Mr(Cr<sub>2</sub>O<sub>3</sub>)=52*2+16*3=152gr/mol.`,
        desc2: 'm(Cr<sub>2</sub>O<sub>3</sub>)=25 gr',
        e: '1 molekula oksidte 2*6,02*10<sup>23</sup>=12,04*10<sup>23</sup> atom  xrom bar',
        a: `152gr`,
        b: `12*10<sup>23</sup>(Cr)`,
        c: `25`,
        d: `x`,
        x: `1,98*10<sup>23</sup>`
    }, {
        id: 10,
        task: `Quraminda 1,3 mol Fe atomlari bolǵan Fe<sub>2</sub>O<sub>3</sub> tiń massasin esaplań?`,
        desc: `Berilgen:Mr(Fe<sub>2</sub>O<sub>3</sub>)=56*2+16*3=160gr/mol`,
        desc2: 'n(Fe<sub>2</sub>O<sub>3</sub>)=1,3 mol',
        a: `160gr`,
        b: `2 mol(Fe)`,
        c: `x`,
        d: `1,3mol`,
        x: `104gr`
    }, {
        id: 11,
        task: `Quraminda  1,505*10<sup>24</sup> dana suw molekulasi bolǵan suwdiń molekulasiniń massasin tabiń?`,
        desc: `Berilgen:Mr(H<sub>2</sub>O)=1*2+16=18gr/mol`,
        desc2: '1,505*10<sup>24</sup> dana molekula sani',
        a: `18gr`,
        b: `6,02*10<sup>23</sup>`,
        c: `x`,
        d: `1,505*10<sup>24</sup>`,
        x: `45 gr`
    }, {
        id: 12,
        task: `Quraminda  6,02*10<sup>22</sup> dana molekula bolǵan  temir(II) oksidiniń (FeO) niń massasin tabiń?`,
        desc: `Berilgen:Mr(FeO)=56+16=72gr`,
        desc2: '6,02*10<sup>22</sup> dana molekula sani',
        a: `72gr`,
        b: `6,02*10<sup>23</sup>`,
        c: `x`,
        d: `6,02*10<sup>22</sup>`,
        x: `7,2gr`
    }, {
        id: 13,
        task: `Quraminda  5,5*10<sup>23</sup>  dana kislorod atomi bolǵan  K<sub>2</sub>O niń massasin tabiń? `,
        desc: `Berilgen: Mr(K<sub>2</sub>O )=39*2+16=94`,
        desc2: '5,5*10<sup>23</sup>  dana kislorod atomi sani',
        a: `94gr`,
        b: `6,02*10<sup>23</sup>`,
        c: `x`,
        d: `5,5*10<sup>23</sup>`,
        x: `85,9gr`
    }, {
        id: 14,
        task: `Quraminda 2*10<sup>23</sup> dana mis atomlari bolǵan CuO niń massasin tabiń?`,
        desc: ` Berilgen:Mr(CuO)=64+16=80gr`,
        desc2: '2*10<sup>23</sup> dana mis atomlar sani',
        a: `80gr`,
        b: `6,02*10<sup>23</sup>`,
        c: `x`,
        d: `2*10<sup>23</sup>`,
        x: `26,57gr`
    }, {
        id: 15,
        task: `16gr mis(II) oksidinde qansha molekula boladi?`,
        desc: `Berilgen: Mr(CuO)=64+16=80gr/mol.`,
        desc2: 'm(CuO)=16gr',
        a: `80gr`,
        b: `6,02*10<sup>23</sup>`,
        c: `16gr`,
        d: `x`,
        x: `1,204*10<sup>23</sup>`
    }, {
        id: 16,
        task: `Quraminda 12,04*10<sup>23</sup> dana kislorod atomlarin tutqan  temir (III)Fe<sub>2</sub>O<sub>3</sub> niń muǵdarin tabiń?`,
        desc: `Berilgen:Mr(Fe<sub>2</sub>O<sub>3</sub>)=56*2+16*3=160 gr/mol`,
        desc2: '12,04*10<sup>23</sup> dana kislorod atomlari sani',
        a: `1`,
        b: `6,02*10<sup>23</sup>*3`,
        c: `x`,
        d: `1,204*10<sup>23</sup>`,
        e: '1mol (Fe<sub>2</sub>O<sub>3</sub>)',
        f: '3mol(O)',
        x: `0,666mol`
    }, {
        id: 17,
        task: `Quraminda 1,15*10<sup>23</sup> dana marganets atomlarin tutqan marganets(VII)oksidiniń(Mn<sub>2</sub>O<sub>7</sub>) muǵdarin tabiń?`,
        desc: `Berilgen:Mr(Mn<sub>2</sub>O<sub>7</sub>)=55*2+16*7=222gr/mol`,
        desc2: `1,15*10<sup>23</sup>  dana marganets atomlari sani`,
        a: `1mol`,
        b: `6,02*10<sup>23</sup>`,
        c: `x`,
        d: `1,15*10<sup>23</sup>`,
        e: '1mol(Mn<sub>2</sub>O<sub>7</sub>)',
        f: '2mol(Mn)',
        x: `0,191 mol`
    }, {
        id: 18,
        task: `Quraminda 3,01*10<sup>23</sup>dana  molekula tutqan xrom (III) Cr<sub>2</sub>O<sub>3</sub> oksidiniń muǵdarin tabiń?`,
        desc: `Berilgen: Mr(Cr<sub>2</sub>O<sub>3</sub>)=52*2+16*3=152gr/mol`,
        desc2: `3,01*10<sup>23</sup>dana  molekula sani`,
        a: `1mol`,
        b: `6,02*10<sup>23</sup>`,
        c: `x`,
        d: `3,01*10<sup>23</sup>`,
        x: `0,5 mol`
    }
];


const datas2 = [
    {
        id: 1,
        task: 'Temir (III) (Fe<sub>2</sub>O<sub>3</sub>) oksidinde temir neshe % ti quraydi? ',
        desc: [' Berilgen: Mr(Fe<sub>2</sub>O<sub>3</sub>) =56*2+16*3=160gr/mol',
            'Ar(Fe)=56 gr'],
        a: '160gr',
        b: '100%',
        c: '112gr',
        d: 'x',
        x: '70%'
    },

    {
        id:4,
        task:'  Element oksidi  EO<sub>3</sub>  quramǵa iye.' +
            '  Bul oksidtegi kislorodtiń massa úlesi 60% ' +
            ' ke teń. Bul qaysi element?',
        desc:[
            'Berilgen m.u (O)=60%',
            '(m.u E%= 100%-60%=40% )'
        ],
        a:'48gr',
        b:'60%(O)',
        c:'x',
        d:'40%(E)',
        x:'32gr(S), Oksid: SO<sub>3</sub>',
        e:'Birikpede 3 dana kislorod atomlari' +
            ' bar ekenligin ekenligin esapqa alamiz:16*3=48 gr'
    },
    {
        id:5,
        task:'Ayrim element oksidlengende +4' +
            ' oksidleniw dárejesin kórsetedi.' +
            ' Bul elementtiń oksidtegi massa' +
            ' úlesi 71,17 %. Bul qanday element?',
        desc:[
            'Berilgen: E<sup>+4</sup>O<sub>2</sub>',
            '(O%= 100-71,17=28,83% )'
        ],
        a:'32gr',
        b:'28,83%',
        c:'x',
        d:'71,17%',
        x:'78,9gr(Se).Oksid: SeO<sub>2</sub>',
        e:'Birikpede 2 dana kislorod atomi bar: 2*16=32gr'
    },
    {
        id:6,
        task:'Massasi 16 gr bolǵan element massasi' +
            ' 6,4 gr bolǵan  molekuyar kislorod penen' +
            ' birigip EO quramli oksid payda etedi.' +
            ' Bul qanday element ekenligin aniqlań?',
        desc:[
            'Berilgen: oksid-EO',
            'm(E)=16gr,  m(O)=6,4gr'
        ],
        a:'16gr',
        b:'6,4gr',
        c:'x',
        d:'16gr',
        x:'40gr(Ca). Oksid:CaO '
    },
    {
        id:7,
        task:'Ayrim metal oksidi quraminda ' +
            ' Me<sub>2</sub>O<sub>3</sub> eń ápiwayi formula menen ' +
            'kórsetiliwi múmkin . Massasi 76,5 gr ' +
            'bolǵan oksidtiń quraminda massasi 40,5 ' +
            'gr bolǵan metall bar.  Bul metall qaysi?',
        desc:[
            'Berilgen: Me<sub>2</sub>O<sub>3</sub>',
            'm(O)=76,5gr,  m(Me)=40,5gr',
            'm(O)=m(Me<sub>2</sub>O<sub>3</sub>)-m(Me)'
        ],
        a:'40,5gr',
        b:'36gr',
        c:'x',
        d:'48gr',
        x:'27gr (Al), oksid: Al<sub>2</sub>O<sub>3</sub>',
        e:'m(O)=76,5-40,5=36 gr',
        f:'x= 54gr , m(Me)=54:2'
    }]

const datas3 = [
    {id:1,
        task:'Kúkirt oksidindegi kúkirt hám kislorodtiń massa úlesi 40%  hám 60% ti quraydi. Bul oksidtiń formulasin tabiń?',
        desc:[' Berilgen: S=40%, O=60%  '],
        solution:[
            'Esaplaw ushin oksid massasi 100 gr dep alinadi  ',
            'm(S)=40gr, m(O)=60gr  ',
            'Kúkirttiń  bir atomina(32 gr) saykes keletuǵin kislorod massasi esaplanadi'
        ],
        a:'40gr(S)',
        b:'60gr(O)',
        c:'32gr',
        d:'x',
        f:'x=48 gr',
        solution2:[
            'Birikpedegi atomlar qatnasin esaplaymiz',
            '32:32=1(S) ,   48:16=3(O)'
        ],
        x:'Birikpeniń formulasi :SO<sub>3</sub>'
    },
    {id:2,
        task:'Fosfor  oksidinde  fosfor  hám' +
            ' kislorodtiń massa úlesi 43,66% hám 56,36%ti' +
            '  quraydi. Bul oksidtiń formulasin tabiń?',
        desc:['Berilgen: P=43,66%, O=56,36% '],
        solution:[
            'Esaplawlar ushin oksid massasi 100gr dep alinadi',
            'm(P)=43,66gr, m(O)=56,36gr',
            'Fosfordiń bir atomina(31gr) tuwri keletuǵin kislorod massasi esaplanadi'
        ],
        a:'43,66(P)gr',
        b:'56,36(O)gr',
        c:'31gr',
        d:'x',
        f:'x=24 gr  ',
        solution2:[
            'Birikpedegi atomlar qatnasin esaplaymiz',
            '31:31=1 (P),  24:16=1,5(P)',
            '1(P)*2=2,    1,5(P)*2=3 '
        ],
        x:'Birikpeniń  formulasi:  P<sub>2</sub>O<sub>3</sub>'
    },
    {id:3,
        task:'Azot oksidlerinen birinde azot hám' +
            ' kislorodtiń massa úlesleri 7:20 ǵa teń bul' +
            ' oksidtiń formulasi qanday?',
        desc:['Berilgen: birikpedegi elementlerdiń massa úles qatnaslari',
            'm.ú(N)=7gr : m.ú(O)=20gr'
        ],
        solution:[
            'Azottiń bir atomina (14gr) sáykes keletuǵin kislorod massasi esaplanadi',
        ],
        a:'7gr',
        b:'20gr',
        c:'14gr',
        d:'x',
        f:'x=40gr ',
        solution2:[
            'Birikpedegi atomlar qatnasi esaplanadi',
            '14:14=1(N)*2=2,   40:16=2,5 (O)*2=5 ',
        ],
        x:'Birikpeniń formulasi: N<sub>2</sub>O<sub>5</sub>'
    },
    {id:4,
        task:'Fosfor oksidlerinen birinde fosfordiń 46,5 ' +
            'awirliq bólegine kislorodtiń 60 awirliq bólegi ' +
            'tuwri keledi. Oksidtiń formulasin tabiń?',
        desc:['Berilgen: birikpedegi elementlerdiń massa úles qatnaslari ',
            ' m.ú(P)=46,5gr : m.ú (O)=60gr'
        ],
        solution:[
            'Fosfordiń bir atomina (31gr) ' +
            'sáykes keletuǵin kislorod massasi esaplanadi ',
        ],
        a:'46,5gr',
        b:'60gr',
        c:'31gr',
        d:'x',
        f:'x=40gr',
        solution2:[
            'Birikpedegi atomlardin’ qatnasin esaplaymiz',
            '31:31=1(P)*2=2 ,  40:16=2,5(O)*2=5',
        ],
        x:'Birikpeniń  formulasi:  P<sub>2</sub>O<sub>5</sub>'
    },
    {id:5,
        task:'Azot oksidlerinen birinde azottiń massa úlesi 30,4% ti' +
            ' quraydi.  Bul qaysi oksid?',
        desc:['Berilgen: m.ú (N)=30,4%',
            'm.ú(O)=100%-30,4%=69,6%'
        ],
        solution:[
            'Azottiń bir atomina (14gr) sáykes keletuǵin kislorod massasi esaplanadi ',
        ],
        a:'30,4gr',
        b:'69,6gr',
        c:'14gr',
        d:'x',
        f:'x=32gr',
        solution2:[
            'Birikpedegi atomlardin’ qatnasin esaplaymiz',
            '14:14=1(N),  32:16=2(O)',
        ],
        x:'Birikpeniń formulasi: NO<sub>2</sub>'
    }

]


const datas4=[
    {id:1,
        task:'Massasi 7,1 gr fosfor (V) oksidin aliw ' +
            'ushin fosfordiń qanday massasin jaǵiw kerek?',
        desc:['Berilgen: Mr(P<sub>2</sub>O<sub>5</sub>)=31*2+16*5=204gr/mol',
            'm(P<sub>2</sub>O<sub>5</sub>)=7,1gr'
        ],
        solution:['4P+5O<sub>2</sub>→2P<sub>2</sub>O<sub>5</sub>'],
        a:'124gr',
        b:'204gr',
        c:'x',
        d:'7,1gr',
        x:'4,31 gr P'
    },
    {id:2,
        task:'Massasi 80gr bolǵan CaCO<sub>3</sub> qizdirilǵanda qansha  litr CO<sub>2</sub> payda boladi?',
        desc:['Berilgen: Mr(CaCO<sub>3</sub>)=40+12+16*3=100gr/mol ',
            'm(CaCO<sub>3</sub>)=80 gr'
        ],
        solution:['CaCO<sub>3</sub>→CaO+CO<sub>2</sub>↑'],
        a:'100gr',
        b:'22,4 l',
        c:'80gr',
        d:'x',
        x:'17,92 l CO<sub>2</sub>'},

    {id:4,
        task:'Massasi 71gr bolǵan fosfor(V) oksidi suw menen reakciyaǵa kiriskende neshe gr kislota payda boladi?',
        desc:['Berilgen: m(P<sub>2</sub>O<sub>5</sub>)=71gr',
            'Mr(P<sub>2</sub>O<sub>5</sub>)=31*2+16*5=142gr/mol',
            'Mr(H<sub>2</sub>SO<sub>4</sub>)=1*2+32+16*4=98'
        ],
        solution:['P<sub>2</sub>O<sub>5</sub>+6H<sub>2</sub>SO<sub>4</sub>→4H<sub>3</sub>PO<sub>4</sub>'],
        a:'284gr',
        b:'392gr',
        c:'71gr',
        d:'x',
        x:'98gr'},
    {id:5,
        task:'Massasi 24 gr kúkirt janǵanda qansha kúkirt(IV) oksidi payda boladi?',
        desc:['Berilgen: Mr(SO<sub>2</sub>)=32+16*2=64gr',
            'm(S)=24gr',
            'Ar(S)=32gr'
        ],
        solution:['S+O<sub>2</sub>→SO<sub>2</sub'],
        a:'32gr',
        b:'64gr',
        c:'24gr',
        d:'x',
        x:'48 gr'
    },
]

const datas5=[
    {id:1,
        task:'Muǵdari 0,25 mol bolǵan fosfat kislota qansha massani quraydi?',
        desc:[
            'Berilgen: Mr(H<sub>3</sub>PO<sub>4</sub>)=1*3+31+16*4=98gr/mol',
            'n=0,25 mol H<sub>3</sub>PO<sub>4</sub>'],
        a:'1mol',
        b:'98 gr',
        c:'0,25mol',
        d:'x ',
        x:' x=24,5 gr'

    },
    {id:2,
        task:'Muǵdari 1,5 mol bolǵan nitrat kislota qansha massani quraydi?',
        desc:[
            'Berilgen: Mr(HNO<sub>3</sub>)=1+14+16*3=63gr/mol',
            'n(HNO<sub>3</sub>)=1,5 mol'
        ],
        a:'1mol',
        b:'63gr',
        c:'1,5',
        d:'x',
        x:'94,5gr'

    },
    {id:3,
        task:'Massasi 73 gr xlorid kislotasiniń  muǵdarin tabiń?',
        desc:[
            'Berilgen: Mr(HCl)=1+35,5=36,5gr/mol',
            'm(HCl)=73 gr'],
        a:'36,5gr',
        b:'1mol  ',
        c:'73gr',
        d:'x ',
        x:'2 mol'

    },
    {id:4,
        task:'Massasi 196 gr sulfat kislota (H<sub>2</sub>SO<sub>4</sub> )' +
            ' qansha muǵdardi quraydi?',
        desc:[
            'Berilgen: Mr(H<sub>2</sub>SO<sub>4</sub>)=1*2+32+16*4=98 gr/mol',
            'm(H<sub>2</sub>SO<sub>4</sub>)=196gr'],
        a:'98gr',
        b:'1mol',
        c:'196gr',
        d:'x',
        x:'2 mol'

    },
    {id:5,
        task:'Quraminda  3 mol atomliq kislorod bolǵan sulfat' +
            ' kislotasi (H<sub>2</sub>SO<sub>4</sub>)niń massasin tabiń?',
        desc:[
            'Berilgen:Mr(H<sub>2</sub>SO<sub>4</sub>) =1*2+32+16*4=98gr/mol',
        ],
        solution: ['Sulfat kislotasiniń 1 molekulasinda 4 dana atomliq' +
        ' kislorod bar ekenligin esapqa alamiz'],
        a:'98gr',
        b:'4mol',
        c:'x',
        d:'3mol',
        x:'73,5 gr '

    },
    {id:6,
        task:'Massasi 149 gr fosfat kislotasinda(H<sub>3</sub>PO<sub>4</sub>)' +
            ' qansha mol atomliq kislorod bar?',
        desc:[
            'Berilgen: Mr(H<sub>3</sub>PO<sub>4</sub>)=1*3+31+16*4=98gr/mol',
            'm(H<sub>3</sub>PO<sub>4</sub>)=149 gr'],
        solution:[
            'Fosfat kislotasiniń 1 molekulasinda 4 ' +
            'dana atomliq kislorod bar ekenligin esapqa alamiz',
        ],
        a:'98gr',
        b:'4 mol',
        c:'149gr',
        d:'x',
        x:'x =6,08 mol '

    },
    {id:7,
        task:'Quraminda  3,01*10<sup>23</sup> dana kislorod atomlarin tutqan ' +
            'fosfat  kislotaniń massasin tabiń?',
        desc:[
            'Berilgen:Mr(H<sub>3</sub>PO<sub>4</sub>)=1*3+31+16*4=98gr/mol',
            '3,01*10<sup>23</sup> dana kislorod atomlari sani'],
        solution:[
            'Fosfat kislotasiniń 1 molekulasinda 4 ' +
            'dana atomliq kislorod bar ekenligin esapqa alamiz',
        ],
        a:'6,02*10<sup>23</sup>*4',
        b:'98gr ',
        c:'3,01*10<sup>23</sup>',
        d:'x',
        x:'12,25gr'
    },
    {id:8,
        task:'Quraminda 1,15*10<sup>23</sup> dana vodorod atomlarin ' +
            'tutqan fosfat kislotasiniń(H<sub>3</sub>PO<sub>4</sub>) massasin tabiń',
        desc: [
            'Berilgen:Mr(H<sub>3</sub>PO<sub>4</sub>)=1*3+31+16*4=98gr/mol',
            '1,15*10<sup>23</sup> dana vodorod atomlari sani'],
        solution:[
            'Fosfat kislotasiniń 1 molekulasinda 3 ' +
            'dana atomliq vodorod bar ekenligin esapqa alamiz',
        ],
        a:'6,02*10<sup>23</sup>*3',
        b:'98gr',
        c:'1,15*10<sup>23</sup>',
        d:'x',
        x:'6,24 gr'

    },
    {id:9,
        task:'Quraminda 7,03*10<sup>23</sup>' +
            ' dana molekula tutqa  nitrat kislotasiniń massasin tabiń ',
        desc: ['Berilgen:Mr(HNO<sub>3</sub>) =1+14+16*3=63gr/mol',
            '7,03*10<sup>23</sup> dana molekula sani'],
        a:'63gr',
        b:'6,02*10<sup>23</sup>',
        c:'x',
        d:'7,03*10<sup>23</sup>',
        x:'73,56gr'

    },
    {id:10,
        task:'Quraminda 9,03*10<sup>23</sup> dana molekula' +
            ' tutqan xlorid kislotasiniń massasin tabiń?',
        desc:[
            'Berilgen:Mr(HCl)=1+35,5=36,5gr/mol',
            '9,03*10<sup>23</sup> dana molekula sani'],
        a:'6,02*10<sup>23</sup>',
        b:'36,5gr',
        c:'9,03*10<sup>23</sup>',
        d:'x',
        x:'54,75gr '

    },
    {id:11,
        task:'Quraminda 3,01*10<sup>23</sup> dana   kislorod  atomin  ' +
            'tutqan  nitrat  kislotasiniń (HNO<sub>3</sub>)  massasin tabiń?',
        desc:['Berilgen: Mr(HNO<sub>3</sub>)=1+14+16*3=63gr/mol',
            '3,01*10<sup>23</sup> dana   kislorod  atomi sani'],
        solution:[
            'Nitrat kislotasiniń 1 molekulasinda 3 ' +
            'dana atomliq kislorod bar ekenligin esapqa alamiz',
        ],
        a:'6,02*10<sup>23</sup>*3',
        b:'63gr',
        c:'3,01*10<sup>23</sup>',
        d:'x',
        x:'10,5gr'

    },
    {id:12,
        task:'Quraminda 18,06*10<sup>23</sup> dana  kislorod' +
            ' atomin tutqan fosfat kislotasiniń muǵdarin tabiń?',
        desc:[
            'Berilgen:Mr(H<sub>3</sub>PO<sub>4</sub>)=98gr/mol',
            '18,06*10<sup>23</sup>dana kislorod atom sani'],
        solution:[
            'Fosfat kislotasiniń 1 molekulasinda' +
            ' 4 dana atomliq kislorod bar ekenligin esapqa alamiz',
        ],
        a:'6,02*10<sup>23</sup>*4',
        b:'1mol',
        c:'18,06*10<sup>23</sup>',
        d:'x',
        x:'0,75mol'

    },
]

const datas6=[
    {
        id:2,
        task:'Nitrat kislotasinda (HNO<sub>3</sub>) azot neshe % ti quraydi?',
        desc:['Berilgen: Mr(HNO<sub>3</sub>)=1+14+16*3=63gr/mol',
            'Ar(N)=14 gr'],
        a:'63gr',
        b:'100%',
        c:'14gr',
        d:'x',
        x:'22,22%'
    },
    {
        id:3,
        task:'Xlorid kislotasinda( HCl) xlor neshe % ti quraydi? ',
        desc:['Berilgen:Mr(HCl)=1+35,5=36,5gr/mol','Ar(Cl)=35,5gr'],
        a:'36,5gr',
        b:'100%',
        c:'35,5gr',
        d:'x',
        x:'97,26 %'
    },
    {
        id:4,
        task:'Fosfat kislotasinda (H<sub>3</sub>PO<sub>4</sub>) ' +
            'fosfor neshe % ti quraydi?',
        desc:['Berilgen: Mr(H<sub>3</sub>PO<sub>4</sub>)=1*3+31+16*4=98gr/mol','Ar(P)=31'],
        a:'98gr',
        b:'100%',
        c:'31gr',
        d:'x',
        x:'31,63%'
    },
    {
        id:5,
        task:'Perxlorat kislotada xlor neshe %  ti quraydi?',
        desc:['Berilgen: Mr(HClO<sub>4</sub>)=1+35,5+16*4=100,5gr/mol','Ar(Cl)=35,5gr'],
        a:'100,5gr',
        b:'100%',
        c:'35,5gr',
        d:'x',
        x:'35,32%'
    },
]

const datas7=[
    {
        id:1,
        task:'Ximiyaliq birikpe quramina H,P,O elementleri kiredi. Elementlerdiń massa ulesleri  ' +
            'sáykes túrde H-3,06%,P-31,63%,O-65,3% formulasi qanday?',
        desc:'Berilgen: H-3,06%,P-31,63%,O-65,3%',
        solution:['Esaplaw ushin birikpe massasi 100gr dep alinadi:',
            'H-3,06gr, P-31,63gr, O-48,97gr',
            'Vodorod massasi 1 gr ekenligin esapqa alip 1 gr vodorod penen birigetugin atomlar massasi esaplanadi ' +
            'hám tabilǵan mánislerden atomlar qatnasi esaplanadi'
        ],
        solution1:[
            {   id:1,
                a:'3,06gr',
                b:'31,63gr',
                c:'65,3gr'
            },
            {   id:2,
                a:'1gr',
                b:'x<sub>1</sub>',
                c:'x<sub>2</sub>',
                x1:'x<sub>1</sub>=10,33',
                x2:'x<sub>2</sub>=21,34',
                e:'1:1=1(H)*3=3,   10,33:31=0,333(P)*3=1,   21,34:16=1,33(O)*3=4'
            }
        ],
        x:'Birikpeniń formulasi:H<sub>3</sub>PO<sub>4</sub>'
    },
    {
        id:2,
        task:'Ayrim kislotaniń quraminda H-2,2%, I-55,7%, O-42,1%' +
            'ti quraydi. Usi kislotaniń eń ápiwayi formulasin tabiń?',
        desc:'Berilgen: H-2,2%, I-55,7%, O-42,1%',
        solution:['Esaplaw ushin birikpe massasi 100gr dep alinadi:',
            'H-2,2gr, I-55,7gr, O-42,1gr',
            'Vodorod massasi 1 gr ekenligin esapqa alip 1 gr vodorod penen birigetugin' +
            ' atomlar massasi esaplanadi hám tabilǵan mánislerden atomlar qatnasi esaplanadi'
        ],
        solution1:[
            {   id:1,
                a:'2,2gr',
                b:'55,7gr',
                c:'42,1gr'
            },
            {   id:2,
                a:'1gr',
                b:'x<sub>1</sub>',
                c:'x<sub>2</sub>',
                x1:'x<sub>1</sub>=25,31gr',
                x2:'x<sub>2</sub>=19,13gr',
                e:'1:1=1(H)*5=5,     25,31:127=0,199(I)*5=1,  19,13:16=1,19*5=6'
            }
        ],
        x:'Birikpeniń formulasi:H<sub>5</sub>IO<sub>6</sub>'
    },
    {
        id:3,
        task:'Birikpeniń quraminda H-2,73% , Cl-97,26% ti quraydi.Birikpeniń formulasin tabiń?',
        desc:'Berilgen: H-2,73% , Cl-97,26%',
        solution:['Esaplaw ushin birikpe massasi 100gr dep alinadi:',
            'H-2,73gr, Cl-97,26gr',
            'Vodorod massasi 1 gr ekenligin esapqa alip 1 gr vodorod penen birigetugin atomlar' +
            'massasi esaplanadi hám tabilǵan mánislerden atomlar qatnasi esaplanadi'
        ],
        solution1:[
            {   id:1,
                a:'2,73gr',
                b:'97,26gr ',

            },
            {   id:2,
                a:'1gr',
                b:'x',
                x:'35,5gr',
                e:'1:1=1(H),    35,5:35,5=1(Cl)'
            }
        ],
        x:'Birikpeniń formulasi :HCl'
    },
    {
        id:4,
        task:'Belgisiz kislotaniń quraminda ' +
            'H-1,587%, N-22,22%, O-76,19% ti quraydi. Kislotaniń formulasin tabiń?',
        desc:'Berilgen: H-1,587%, N-22,22%, O-76,19%',
        solution:['Esaplaw ushin birikpe massasi 100gr dep alinadi:',
            'H-1,587gr, N-22,22gr, O-76,19gr',
            'Vodorod massasi 1 gr ekenligin esapqa alip 1 gr vodorod penen birigetugin atomlar massasi esaplanadi ' +
            'hám tabilǵan mánislerden atomlar qatnasi esaplanadi'
        ],
        solution1:[
            {   id:1,
                a:'1,587gr',
                b:'22,22gr',
                c:'76,19gr'
            },
            {   id:2,
                a:'1gr',
                b:'x<sub>1</sub>',
                c:'x<sub>2</sub>',
                x1:'x<sub>1</sub>=14gr',
                x2:'x<sub>2</sub>=48gr',
                e:'1:1=1(H),    14:14=1(N),   48:16=3(O)'
            }
        ],
        x:'Birikpeniń formulasi  HNO<sub>3</sub>'
    },
    {
        id:5,
        task:'Belgisiz birikpeniń quraminda H-1,234%, Br-98,76% ti quraydi. ' +
            'Birikpeniń formulasin tabiń?',
        desc:'Berilgen: H-1,234%, Br-98,76%',
        solution:['Esaplaw ushin birikpe massasi 100gr dep alinadi:',
            'H-1,234gr, Br-98,76gr, ',
            'Vodorod massasi 1 gr ekenligin esapqa alip 1 gr vodorod penen birigetugin atomlar massasi esaplanadi ' +
            'hám tabilǵan mánislerden atomlar qatnasi esaplanadi'
        ],
        solution1:[
            {   id:1,
                a:'1,234gr',
                b:'98,76gr',

            },
            {   id:2,
                a:'1gr',
                b:'x',
                x:'80gr',
                e:'1:1=1(H),  80:80=1(Br) '
            }
        ],
        x:'Birikpeniń formulasi:HBr'
    }

]

const datas8=[
    {
        id:1,
        task:'Massasi 36,5 gr xlorid kislotasin aliw ushin  qansha litr vodorod  kerek?',
        desc:[
            'Berilgen: Mr(HCl)=1+35,5=36,5gr/mol',
            'm(HCl)=36,5 gr'],
        a:'x',
        b:'36,5gr',
        c:'22,4',
        d:'73gr ',
        x:'11,2  l H2',
        e:'H<sub>2</sub>+Cl<sub>2</sub>→2HCl'
    },
    {
        id:2,
        task:'Massasi 1,89 gr nitrat kislotani neytrallaw ' +
            'ushin kerek bolatuǵin natriy gidroksidiniń massasin tabiń?  ',
        desc:[
            'Berilgen:Mr(HNO<sub>3</sub>)=1+14+16*4=63gr/mol',
            'Mr(NaOH)=23+16+1=40gr/mol',
            'm(HNO<sub>3</sub>)=1,89 gr'],
        a:'63gr',
        b:'40gr',
        c:'1,89',
        d:'x',
        x:'1,2gr',
        e:'HNO<sub>3</sub>+NaOH→NaNO<sub>3</sub>+H<sub>2</sub>O'
    },
    {
        id:3,
        task:'Massasi 49 gr nitrat kislotasi fosfor(V)oksidi ' +
            'menen reaktsiyaǵa kiriskende neshe gr fosfat kislota payda boladi?',
        desc:[
            'Berilgen: Mr(HNO<sub>3</sub>) =1+14+16*3=63gr/mol',
            'Mr(H<sub>3</sub>PO<sub>4</sub>)=1*3+31+16*4=98gr/mol',
            'm(HNO<sub>3</sub>)=49gr'],
        a:'126gr',
        b:'196gr',
        c:'49gr',
        d:'x',
        x:'76,22 gr',
        e:'P<sub>2</sub>O<sub>5</sub>+2HNO<sub>4</sub>→2H<sub>3</sub>PO<sub>4</sub>+N<sub>2</sub>O<sub>5</sub>5 '
    },
    {
        id:4,
        task:'Massasi 12gr uglerod  konc  nitrat kislotasi ' +
            'menen tásirleskende qansha litr karbonat angidridi payda boladi?',
        desc:[
            'Berilgen:Ar(C) =12gr',
            'Mr(HNO<sub>3</sub>) =1+14+16*3=63gr/mol',
            'm(C)=12 gr'],
        a:'36gr',
        b:'67,2 l',
        c:'12gr',
        d:'x',
        x:'22,4 l',
        e:'3C+4HNO<sub>3(konc)</sub>→ 3CO<sub>2</sub>↑+4NO<sub>2</sub>+2H<sub>2</sub>O'
    },
    {
        id:5,
        task:'Massasi 17,5 gr xlorid kislotasi gúmis nitrati menen' +
            ' reaktsiyaǵa kiriskende qansha gr  nitrat kislota  payda boladi?',
        desc:[
            'Berilgen:Mr(HCl) =1+35,5=36,5gr/mol',
            'Mr(HNO<sub>3</sub>) =1+14+16*3=63gr/mol',
            'm(HCl)=17,5 gr'],
        a:'36,5gr',
        b:'63gr',
        c:'17,5gr',
        d:'x',
        x:'30,2gr',
        e:'HCl+AgNO<sub>3</sub>→AgCl+HNO<sub>3</sub>'
    },

]


const datas9 = [
    {
        id:1,
        task:'Massasi 156gr bolǵan natriy gidroksidiniń muǵdarin tabiń?',
        desc:['Berilgen: Mr(NaOH)=23+16+1=40gr/mol','m(NaOH)=156 gr'],
        a:'40gr',
        b:'1 mol',
        c:'156gr',
        d:'x',
        x:'3,9 mol'
    },
    {
        id:2,
        task:'Muǵdari 3,5 mol bolǵan kalciy gidroksidiniń massasin tabiń?',
        desc:['Berilgen:Mr(Ca(OH)<sub>2</sub>)=40+2*(16+1)=74gr/mol',
            'n(Ca(OH)<sub>2</sub>)=3,5 mol'],
        a:'1mo',
        b:'74gr',
        c:'3,5mol',
        d:'x',
        x:'259 gr'
    },
    {
        id:3,
        task:'Massasi 120 gr kaliy gidroksidinde (KOH) qansha mol atomliq kislorod bar?',
        desc:['Berilgen: Mr(KOH)=39+16+1=56 gr/mol',
            'm(KOH)=120 gr'],
        a:'56gr',
        b:'1 mol',
        c:'120gr',
        d:'x ',
        x:'2,14 mol'
    },
    {
        id:4,
        task:'Quraminda  3,01*10<sup>23</sup> dana kislorod atomlarin tutqan ' +
            'alyuminiy gidroksidiniń massasin tabiń?',
        desc:['Berilgen:Mr(Al(OH)<sub>3</sub>)=27+2*(16+1)=78 gr/mol',
            '3,01*10<sup>23</sup> dana kislorod atomlari sani'],
        a:'6,02*10<sup>23</sup>',
        b:'78gr',
        c:'3,01*10<sup>23</sup>',
        d:'x',
        x:'13gr'
    },
    {
        id:5,
        task:'Quraminda 1,15*10<sup>23</sup>dana kalciy  atomlarin tutqan ' +
            'kalciy gidroksidiniń(Ca(OH)<sub>2</sub> ) massasin tabiń',
        desc:['Berilgen:Mr(Ca(OH)<sub>2</sub>) =40+2*(16+1)=74gr/mol',
            '1,15*10<sup>23</sup> dana kalciy  atomlari sani'],
        a:'6,02*10<sup>23</sup>',
        b:'74gr',
        c:'1,15*10<sup>23</sup>',
        d:'x',
        x:'14,13 gr'
    },
    {
        id:6,
        task:'Quraminda 7,03*10<sup>23</sup> dana molekula tutqan  xrom(III)gidroksidiniń  massasin tabiń ',
        desc:['Berilgen:Mr(Cr(OH)<sub>3</sub>) =52+3*(16+1)=103gr/mol',
            '7,03*10<sup>23</sup> dana molekula sani'],
        a:'103gr',
        b:'6,02*10<sup>23</sup>',
        c:'x',
        d:'7,03*10<sup>23</sup>',
        x:'120,3gr'
    },
    {
        id:7,
        task:' Quraminda  10,03*10<sup>23</sup> dana molekula tutqan  mis gidroksidiniń  massasin tabiń?',
        desc:['Berilgen:Mr(Cu(OH)<sub>2</sub>)=64+2*(16+1)=98 gr/mol',
            '10,03*10<sup>23</sup> dana molekula sani'],
        a:'6,02*10<sup>23</sup>',
        b:'98gr',
        c:'10,03*10<sup>23</sup>',
        d:'x',
        x:'163,3 gr '
    },
    {
        id:8,
        task:'Quraminda 4,01*10<sup>23</sup> dana   kislorod  atomin  tutqan  cink gidroksidiniń  massasin tabiń?',
        desc:['Berilgen:Mr(Zn(OH)<sub>2</sub>)=65+2*(16+1)=99 gr/mol',
            '4,01*10<sup>23</sup> dana   kislorod  atomi sani'],
        a:'6,02*10<sup>23</sup>*2',
        b:'99gr',
        c:'4,01*10<sup>23</sup>',
        d:'x',
        x:'32,97gr'
    },
    {
        id:9,
        task:'Quraminda 18,06*10<sup>23</sup> dana atom vodorod atomlarin tutqan  magniy gidroksidiniń  muǵdarin tabiń?',
        desc:['Berilgen:Mr(Mg(OH)<sub>2</sub>)=24+2*(16+1)=58gr/mol',
            '18,06*10<sup>23</sup> dana atom vodorod atomlari sani'],
        a:'6,02*10<sup>23</sup>*2',
        b:'58gr',
        c:'18,06*10<sup>23</sup>',
        d:'x',
        x:'87gr'
    },


];

const datas10 =    [
    {
        id:1,
        task:'Magniy gidroksidinde (Mg(OH)<sub>2</sub>) kislorod neshe  % ti quraydi?',
        desc:'Berilgen: Mr(Mg(OH)<sub>2</sub>)=24+2*(16+1)=58gr/mol',
        a:'58gr',
        b:'100%',
        c:'32gr',
        d:'x',
        x:'55,17%'
    },
    {
        id:2,
        task:'Temir (III)gidroksidinde  (Fe(OH)<sub>3</sub>) temir  neshe % ti quraydi?',
        desc:'Berilgen: Mr(Fe(OH)<sub>3</sub>)=56+3*(16+1)=107gr/mol',
        a:'107gr',
        b:'100%',
        c:'56gr',
        d:'x',
        x:'52,33%'
    },
    {
        id:3,
        task:'Beriliy gidroksidinde (Be(OH)<sub>2</sub>) vodorod neshe % ti quraydi? ',
        desc:'Berilgen: Mr(Be(OH)<sub>2</sub>)=9+2*(16+1)=43gr/mol',
        a:'43gr',
        b:'100%',
        c:'2gr',
        d:'x',
        x:'4,65%'
    },
    {
        id:4,
        task:'Natriy gidroksidinde  (NaOH) natriy neshe % ti quraydi?',
        desc:'Berilgen:Mr(NaOH)=23+16+1=40gr/mol',
        a:'40gr',
        b:'100%',
        c:'23gr',
        d:'x',
        x:'57,5%'
    },
    {
        id:5,
        task:'Kaliy gidroksidinde kislorod neshe %  ti quraydi?',
        desc:'Berilgen:Mr(KOH)=39+16+1=56gr/mol',
        a:'56gr',
        b:'100%',
        c:'16gr',
        d:'x',
        x:'28,57%'
    }
];


const datas11 = [
    {
        id:1,
        task:'Ximiyaliq birikpe quramina Ca, O, H elementleri kiredi. Elementlerdiń massa ulesleri  ' +
            'sáykes túrde Ca-54%, O-43,3%, H-2,7%  Birikpeniń formulasi qanday?',
        desc:'Berilgen: Ca-54%, O-43,3%, H-2,7% ',
        solution:['Esaplaw ushin birikpe massasi 100gr dep alinadi:',
            'Ca-54gr, O-43,3gr, H-2,7gr',
            'Kalciydiń bir atomina(40gr)  tuwri keletuǵin atomlar qatnasi tabiladi'
        ],
        solution1:[
            {   id:1,
                a:'54gr',
                b:'43,3gr',
                c:'2,7gr'
            },
            {   id:2,
                a:'40gr',
                b:'x<sub>1</sub>',
                c:'x<sub>2</sub>',
                x1:'x<sub>1</sub>=32,07gr',
                x2:'x<sub>2</sub>=2gr',
                d:'Birikpedegi atomlardiń bir-birine qatnasi tabiladi',
                e:'40:40=1(Ca),   32,07:16=2(O),   2:1=2(O)'
            }
        ],
        x:'Birikpeniń formulasi:  Ca(OH)<sub>2</sub>'
    },
    {
        id:2,
        task:'Belgisiz tiykar quraminda  Al-34,61%, O-61,53%, H-3,84% ti quraydi. Usi birikpeniń  eń ápiwayi formulasin tabiń?',
        desc:'Berilgen: Al-34,61%, O-61,53%, H-3,84%',
        solution:['Esaplaw ushin birikpe massasi 100gr dep alinadi:',
            'Al-34,61gr, O-61,53gr,  O-3,84gr',
            'Alyuminiydiń bir atomina (27gr) tuwri keletuǵin atomlar qatnasi tabiladi'
        ],
        solution1:[
            {   id:1,
                a:'34,61gr',
                b:'61,53gr',
                c:'3,84gr'
            },
            {   id:2,
                a:'27gr',
                b:'x<sub>1</sub>',
                c:'x<sub>2</sub>',
                x1:'x<sub>1</sub>=48 gr',
                x2:'x<sub>2</sub>==3gr',
                d:'Birikpedegi atomlardinı bir-birine qatnasi tabiladi',
                e:'27:27=1(Al),     48:48=3(O),  3:1=3(H)'
            }
        ],
        x:'Birikpeniń formulasi: Al(OH)<sub>3</sub>'
    },
    {
        id:3,
        task:'Belgisiz birikpeniń quraminda Cr-50,48% , O-46,6% , H-2,91% ti quraydi. Birikpeniń  formulasin tabiń?',
        desc:'Berilgen: Cr-50,48% , O-46,6% , H-2,91%',
        solution:['Esaplaw ushin birikpe massasi 100gr dep alinadi:',
            'Cr-50,48gr, O-46,6gr, H-2,91gr',
            'Xromniń  bir atomina (52gr) tuwri keletuǵin atomlar qatnasi tabiladi'

        ],
        solution1:[
            {   id:1,
                a:'50,48gr',
                b:'46,6gr',
                c:'2,91gr '
            },
            {   id:2,
                a:'52gr',
                b:'x<sub>1</sub>',
                c:'x<sub>2</sub>',
                x1:'x<sub>1</sub>=48gr',
                x2:'x<sub>2</sub>=3gr',
                d:'Birikpedegi atomlardinı bir-birine qatnasi esaplanadi ',
                e:'52:52=1(Cr),    48:16=3(O)   3:1=3(H)'
            }
        ],
        x:'Birikpeniń formulasi : Cr(OH)<sub>3</sub>'
    },
    {
        id:4,
        task:'Birikpeniń  quraminda temir, kislorod  hám vodorod ' +
            'elementleri bar.  Bul elementler sáykes túrde  ' +
            'Fe-62,2%, O-35,6%, H-2,2%  ti quraydi. Birikpeniń ' +
            'formulasin tabiń?',
        desc:'Berilgen: Fe-62,2%, O-35,6%, H-2,2%',
        solution:['Esaplaw ushin birikpe massasi 100 gr dep alinadi:',
            'Fe-62,2 gr, O-35,6 gr, H-2,2 gr ',
            'Temirdiń bir atomina(56gr) tuwri keletugıin atomlar qatnasi tabiladi'
        ],
        solution1:[
            {   id:1,
                a:'62,2gr',
                b:'35,6gr',
                c:'2,2gr '
            },
            {   id:2,
                a:'56gr',
                b:'x<sub>1</sub>',
                c:'x<sub>2</sub>',
                x1:'x<sub>1</sub>=32gr',
                x2:'x<sub>2</sub>=2gr',
                d:'Birikpedegi atomlardinı bir-birine qatnasi esaplanadi ',
                e:'56:56=1(Fe),    32:16=2(O),   2:1=2(H)'
            }
        ],
        x:'Birikpeniń formulasi: Fe(OH)<sub>2</sub>'
    },
    {
        id:5,
        task:'Belgisiz birikpeniń quraminda  Ba-80,117%, O-18,71% ,' +
            'H-1,17% ti quraydi. Birikpeniń formulasin tabiń?',
        desc:'Berilgen: Ba-80,117%, O-18,71% ,H-1,17%',
        solution:['Esaplaw ushin birikpe massasi 100 gr dep alinadi:',
            'Ba-80,117gr, O-18,71gr, H-1,17',
            'Bariydiń  bir atomina tuwri keletuǵin  atomlar qatnasi tabiladi'
        ],
        solution1:[
            {   id:1,
                a:'80,117gr',
                b:'18,71gr',
                c:'1,17gr'
            },
            {   id:2,
                a:'137gr',
                b:'x<sub>1</sub>',
                c:'x<sub>2</sub>',
                x1:'x<sub>1</sub>=32gr',
                x2:'x<sub>2</sub>=2gr',
                d:'Birikpedegi atomlar qatnasi esaplanadi',
                e:'137:137=1(Ba),  32:16=2(O) , 2:1=2(H)'
            }
        ],
        x:'Birikpeniń formulasi: Ba(OH)<sub>2</sub>'
    }
]

const datas12 = [
    { id:1,
        task:'1mol temir (II)gidroksidin temir(III)gidroksidine aylandiriw ushin qansha l kislorod  kerek?',
        desc:[
            'Berilgen: m(Fe(OH)<sub>2</sub>)=56+2*(16+1)=90gr/mol',
            'n(Fe(OH)<sub>2</sub>=1 mol',

        ],
        solution:[
            '4Fe(OH)<sub>2</sub>+O<sub>2</sub>+2H<sub>2</sub>O→4Fe(OH)<sub>3</sub>',
        ],
        a:'1mol',
        b:'22,4l',
        c:'4mol',
        d:'x',
        x:'5,6 l O<sub>2</sub>'
    },
    { id:2,
        task:'Massasi  5,6 gr nitrat kislotani  neytrallaw ushin kerek bolatuǵin natriy gidroksidiniń massasin tabiń?  ',
        desc:[
            'Berilgen:Mr(HNO<sub>3</sub>)=1+14+48=63gr/mol',
            'Mr(NaOH)=23+16+1=40gr/mol',
            'm(HNO<sub>3</sub>)=5.6gr',

        ],
        solution: [
            'M(HNO<sub>3</sub>)=5,6gr',
            ' HNO<sub>3</sub>+NaOH→NaNO<sub>3</sub>+H<sub>2</sub>O'
        ],
        a:'63gr',
        b:'40gr',
        c:'5,6gr',
        d:'x',
        x:'3,55gr'
    },
    { id:3,
        task:'Massasi 54 gr kaliy gidroksidi alyuminiy xloridi menen reakciyaǵa kiriskende qansha gr  shókpe payda boladi?',
        desc:[
            'Berilgen: Mr(KOH) =39+16+1=56gr/mol',
            'Mr(Al(OH<sub>3</sub>))=27+3*(16+1)=78gr/mol',
            'm(KOH)=54gr',
        ],
        solution: ['3KOH+AlCl<sub>3</sub>→Al(OH)<sub>3</sub>↓+KCl<sub>3</sub>'],
        a:'168gr',
        b:'78gr',
        c:'54gr',
        d:'x',
        x:'25,07 gr Al(OH)<sub>3</sub↓'
    },
    { id:4,
        task:'Massasi 40 gr uglerod (IV) oksidi bariy gidroksidi eritpesi arqali ótkerildi,  bunda qansha shókpe payda boladi?',
        desc:[
            'Berilgen:Mr(CO<sub>2</sub>) =12+16*3=44gr/mol',
            'Mr(Ba(OH)<sub>2</sub>) =137+2*(16+1)=171gr/mol',
            'm(CO<sub>2</sub>)=40 gr',

        ],
        solution:['CO<sub>2</sub>+Ba(OH)<sub>2</sub>→ BaCO<sub>3</sub>↓+H<sub>2</sub>O'],
        a:'44gr',
        b:'197gr',
        c:'40gr',
        d:'x',
        x:'179 gr'
    },
    { id:5,
        task:'Massasi 40gr  xrom(III) gidroksidi xlorid kislotasi menen tásirleskende qansha gr duz payda boladi?',
        desc:[
            'Berilgen:Mr(Cr(OH)<sub>3</sub>) =52+3*(16+1)=103gr/mol',
            'Mr(HCl) =1+35,5=36,5gr/mol',
            'Mr(CrCl<sub>3</sub>) =52+35,5*3=158,5gr/mol',
            'm(Cr(OH)<sub>3</sub>)=40gr',
        ],
        solution: ['Cr(OH)<sub>3</sub>+3HCl→CrCl<sub>3</sub>+3H<sub>2</sub>O'],
        a:'103gr',
        b:'58,5gr',
        c:'40gr',
        d:'x',
        x:'61,55gr CrCl<sub>3</sub>'
    }
]

const datas13= [
    {
        id:1,
        task:'Massasi 80gr bolǵan natriy sulfatiniń  muǵdarin tabiń?',
        desc:[
            'Berilgen: Mr(Na<sub>2</sub>SO<sub>4</sub>)=23*2+32+16*4=142gr/mol',
            'm(Na<sub>2</sub>SO<sub>4</sub>)=80gr'
        ],
        a:'142gr',
        b:'1mol',
        c:'80gr',
        d:'x',
        x:'0,56 mol'
    },
    {
        id:2,
        task:'Muǵdari 1,5 mol bolǵan magniy (II) nitratiniń massasin tabiń?',
        desc:[
            'Berilgen:Mr(Mg(NO<sub>3</sub>)<sub>2</sub>)=24+2*(14+16)=84gr/mol',
            'n(Mg(NO<sub>3</sub>)<sub>2</sub>)=1,5 mol'
        ],
        a:'1mol',
        b:'84gr',
        c:'1,5mol',
        d:'x',
        x:'126 gr'
    },
    {
        id:3,
        task:'Massasi 64 gr cink sulfatinda (ZnSO<sub>4</sub>)  qansha mol atomliq kislorod bar?',
        desc:[
            'Berilgen: Mr(ZnSO<sub>4</sub>)=65+32+4*16=161 gr/mol',
            'm(ZnSO<sub>4</sub>)=64 gr'
        ],
        a:'161gr',
        b:'4mol',
        c:'64gr',
        d:'x',
        x:'1,6 mol '
    },
    {
        id:4,
        task:'Quraminda  1,15*10<sup>23</sup> dana xlor atomlarin tutqan kalciy xloridiniń massasin tabiń?',
        desc:[
            'Berilgen:Mr(CaCl<sub>2</sub>)=40+35,5*2=111 gr/mol',
            ' 1,15*10<sup>23</sup> dana xlor atomlari sani'
        ],
        a:'6,02*10<sup>23</sup>*2',
        b:'111gr ',
        c:'1,15*10<sup>23</sup>',
        d:'x',
        x:'10,6gr'
    },
    {
        id:5,
        task:'Quraminda 3,03*10<sup>23</sup> dana natriy atomlarin tutqan natriy fosfat duziniń massasin tabiń?',
        desc:[
            'Berilgen:Mr(Na<sup>3</sup>PO<sup>4</sup>) =23*3+31+16*4=164gr/mol',
            '3,03*10<sup>23</sup> dana natriy atomlari sani'
        ],
        a:'3*6,02*10<sup>23</sup>',
        b:'164gr',
        c:'3,03*10<sup>23</sup>',
        d:'x',
        x:'27,51 gr'
    },
    {
        id:6,
        task:'Quraminda 4,03*10<sup>23</sup> dana molekula tutqan  kaliy xlorid duziniń massasin tabiń? ',
        desc:[
            'Berilgen:Mr(KCl) =39+35,5=74,5 gr/mol',
            '4,03*10<sup>23</sup> dana molekula sani'
        ],
        a:'74,5gr',
        b:'6,02*10<sup>23</sup>',
        c:'x',
        d:'4,03*10<sup>23</sup>',
        x:'49,87gr'
    },
    {
        id:7,
        task:'Quraminda  5,03*10<sup>23</sup> dana molekula tutqan magniy xloridiniń massasin tabiń?',
        desc:[
            'Berilgen:Mr(MgCl<sub>2</sub>)=24+35,5*2=95gr/mol',
            '5,03*10<sup>23</sup>dana molekula sani'
        ],
        a:'6,02*10<sup>23</sup>',
        b:'95gr',
        c:'5,03*10<sup>23</sup>',
        d:'x',
        x:'79,37gr'
    },
    {
        id:8,
        task:'Quraminda 3,01*10<sup>23</sup> dana   kislorod  atomin  tutqan kaliy nitrat  duziniń  massasin tabiń?',
        desc:[
            'Berilgen:Mr(KNO<sub>3</sub>)=39+14+16*3=101gr/mol',
            '3,01*10<sup>23</sup> dana   kislorod  atomi sani'
        ],
        a:'6,02*10<sup>23</sup>*3',
        b:'101gr',
        c:'3,01*10<sup>23</sup>',
        d:'x',
        x:'77gr'
    },
    {
        id:9,
        task:'Quraminda 12,04*10<sup>23</sup> dana atom kislorod tutqan kalciy fosfat duziniń muǵdarin tabiń?',
        desc:[
            'Berilgen:Mr(Ca<sub>3</sub>(PO<sub>4</sub>)<sub>2</sub>)=40*3+2*(31+16*4)=312gr/mol',
            '12,04*10<sup>23</sup> dana atom sani'
        ],
        a:'6,02*10<sup>23</sup>*8',
        b:'1mol',
        c:'12,04*10<sup>23</sup>',
        d:'x',
        x:'0,25 mol'
    },
]

const datas14= [
    {
        id:1,
        task:'Magniy sulfat duzinda (MgSO<sub>4</sub>) kislorod neshe  % ti quraydi?',
        desc:'Berilgen: Mr(MgSO<sub>4</sub>)=24+32+16*4=120gr/mol',
        a:'120gr',
        b:'100%',
        c:'64gr',
        d:'x',
        x:'53,33%'

    },
    {
        id:2,
        task:'Kaliy nitrat duzinda (KNO<sub>3</sub>) azot neshe % ti quraydi?',
        desc:'Berilgen: Mr(KNO<sub>3</sub>)=39+14+16*3=101gr/mol',
        a:'101gr',
        b:'100%',
        c:'14gr',
        d:'x',
        x:'13,86%'

    },
    {
        id:3,
        task:'Natriy xlorid duzinda (NaCl) xlor neshe % ti quraydi? ',
        desc:'Berilgen: Mr(NaCl)=23+35,5=58,5gr/mol',
        a:'58,5gr',
        b:'100%',
        c:'35,5gr',
        d:'x',
        x:'60,68%'

    },
    {
        id:4,
        task:'Natriy fosfatinda (Na<sub>3</sub>PO<sub>4</sub>) natriy neshe % ti quraydi?',
        desc:'Berilgen:Mr(Na<sub>3</sub>PO<sub>4</sub>)=23*3+31+16*4=164gr/mol',
        a:'164g',
        b:'100%',
        c:'69gr',
        d:'x',
        x:'42,1%'

    },
    {
        id:5,
        task:'Bariy sulfatinda (BaSO<sub>4</sub>) bariy neshe % ti quraydi?',
        desc:'Berilgen:Mr(BaSO<sub>4</sub>)=137+32+16*4=233gr/mol',
        a:'233gr',
        b:'100%',
        c:'137gr',
        d:'x',
        x:'58,8%'

    },
]


const datas15 = [
    {
        id:1,
        task:'Belgisiz birikpe quramina K,Mn,O elementleri kiredi. Elementlerdiń massa ulesleri  sáykes túrde K-24,68%, Mn-34,81%, O-40,55% Birikpeniń formulasi qanday?',
        desc:'Berilgen: K-24,68%, Mn-34,81%, O-40,55%',
        solution:['Esaplaw ushin birikpe massasi 100gr dep alinadi:',
            'K-24,68gr, Mn-34,81gr, O-40,55gr',
            'Kaliydiń bir atomina (39 gr) tuwri keletuǵin atomlar massasi esaplanadi '
        ],
        solution1:[
            {   id:1,
                a:'24,68',
                b:'34,81',
                c:'40,55'
            },
            {   id:2,
                a:'39',
                b:'x<sub>1</sub>',
                c:'x<sub>2</sub>',
                x1:'x<sub>1</sub>=55',
                x2:'x<sub>2</sub>=64',
                d:'Birikpedegi atomlardiń qatnasi esaplanadi',
                e:'39:39=1(K),   55:55=1(Mn),   64:16=4(O)'
            }
        ],
        x:'Birikpeniń formulasi:KMnO<sub>4</sub>'
    },
    {
        id:2,
        task:'Birikpeniń quraminda Ca-29,41, S-23,52%, O-47% ti quraydi. ' +
            'Usi birikpeniń eń ápiwayi formulasin tabiń?',
        desc:'Berilgen: Ca-29,41, S-23,52%, O-47%',
        solution:['Esaplaw ushin birikpe massasi 100gr dep alinadi::',
            'Ca-29,41gr, S-23,52gr, O-47gr',
            'Kalciydiń bir atomina (40gr) tuwri keletuǵin atomlar massasi esaplanadi'
        ],
        solution1:[
            {   id:2,
                a:'29,41gr',
                b:'23,52gr',
                c:'47gr'
            },
            {   id:2,
                a:'40gr',
                b:'x<sub>1</sub>',
                c:'x<sub>2</sub>',
                x1:'x<sub>1</sub>=32gr',
                x2:'x<sub>2</sub>=64gr',
                d:'Birikpedegi atomlardiń bir-birine qatnasi tabiladi',
                e:'40:40=1(Ca),     32:32=1(S),  64:16=4'
            }
        ],
        x:'Birikpeniń formulasi:CaSO<sub>4</sub>'
    },
    {
        id:3,
        task:'Belgisiz birikpeniń quraminda Na-42% , P-19% O-39 % ti quraydi. Birikpeniń formulasin tabiń?',
        desc:'Berilgen: Na-42% , P-19% O-39 %',
        solution:['Esaplaw ushin birikpe massasi 100gr dep alinadi:',
            'Na-42gr, P-19gr, O-39gr',
            'Natriydinı bir atomina(23gr) tuwri keletuǵin atomlar massasi esaplanadi'

        ],
        solution1:[
            {   id:2,
                a:'42gr',
                b:'19gr',
                c:'39gr'
            },
            {   id:2,
                a:'23gr',
                b:'x<sub>1</sub>',
                c:'x<sub>2</sub>',
                x1:'x<sub>1</sub>=10,4gr',
                x2:'x<sub>2</sub>==21,35gr',
                d:'Birikpedegi atomlardinı bir-birine qatnasi esaplanadi ',
                e:'23:23=1(Na)*3=3,    10,4:31=0,33(P)*3=1,   21,35:16(O)=1,33*3=4'
            }
        ],
        x:'Birikpeniń formulasi :Na<sub>3</sub>PO<sub>4</sub>'
    },/*
    {
        id:'4',
        task:'Belgisiz birikpeniń  quraminda  K-52,34%, Cl-47,65% ti quraydi. Birikpeniń formulasin tabiń?',
        desc:'Berilgen: K-52,34%, Cl-47,65%',
        solution:['Esaplaw ushin birikpe massasi 100gr dep alinadi:',
            'K-52,34gr, Cl-47,65gr, ',
            'Kaliydiń bir atomina (39gr) tuwri keletuǵin atomlar qatnasi esaplanadi.'
        ],
        solution1:[
            {   id:2,
                a:'52,34gr',
                b:'47,65gr',
            },
            {   id:2,
                a:'39gr',
                b:'x',
                c:'x=35,5gr',
                d:'Birikpedegi atomlar qatnasi esaplanadi',
                e:'39:39=1(K),    35,5:35,5=1(Cl),   '
            }
        ],
        x:'Birikpeniń formulasi:  KCl'
    },*/
    {
        id:5,
        task:'Belgisiz birikpeniń quraminda Mg-20%, S-26,66%, O-53,33 ti quraydi. Birikpeniń formulasin tabiń?',
        desc:'Berilgen: Mg-20%, S-26,66%, O-53,33',
        solution:['Esaplaw ushin birikpe massasi 100gr dep alinadi:',
            'Mg-20gr, S-26,66gr, O-53,33 ',
            'Magniydiń bir atomina(24gr) tuwri keletuǵin atomlar massasi esaplanadi '
        ],
        solution1:[
            {   id:1,
                a:'20gr',
                b:'26,66gr',
                c:'53,33gr'
            },
            {   id:2,
                a:'24gr',
                b:'x<sub>1</sub>',
                c:'x<sub>2</sub>',
                x1:'x<sub>1</sub>=10,33',
                x2:'x<sub>2</sub>=21,34',
                d:'Birikpedegi atomlar qatnasi esaplanadi',
                e:'24:24=1(Mg),  32:32=1(S), 64:16(O)=4 '
            }
        ],
        x:'Birikpeniń  formulasi: MgSO<sub>4</sub>'
    }
]


const datas16=[
    {
        id:1,
        task:'Massasi 32 gr mis konc nitrat kislotasi menen reakciyaǵa kiriskende qansha massa duz payda boladi?',
        desc:['Berilgen: Mr(Cu(NOM<sub>3</sub>)<sub>2</sub>)=64+2*(14+16*3)=156gr/mol',
            'Ar(Cu)=64gr/mol',
            'm(Cu)=32 gr'],
        solution:['Cu+4HNO<sub>3</sub>→Cu(NO<sub>3</sub>)<sub>2</sub>+2NO<sub>2</sub>↑+2H<sub>2</sub>O'],
        a:'64gr',
        b:'156gr',
        c:'32gr',
        d:'x',
        x:'78gr'

    },
    {
        id:2,
        task:'Massasi 142 gr ammoniy dixromati tarqalǵanda qansha litr azot payda boladi?',
        desc:['Berilgen: Mr((NH<sub>4</sub>)2Cr<sub>2</sub>O7)=2*(14+1*4)+52*2+16*7=252gr/mol',
            'm((NH<sub>4</sub>)<sub>2</sub>Cr<sub>2</sub>O<sub>7</sub>)=142gr',''],
        solution:['(NH<sub>4</sub>)<sub>2</sub>Cr<sub>2</sub>O<sub>7</sub>→Cr<sub>2</sub>O<sub>3</sub>+N<sub>2</sub>+4H<sub>2</sub>O'],
        a:'252gr',
        b:'22,4 l',
        c:'142gr',
        d:'x',
        x:'12,66 l'

    },
    {
        id:3,
        task:'Massasi 120 gr kaliy permanganati xlorid kislota menen tásirleskende qansha gr magniy xloridi payda boladi ?',
        desc:['Berilgen: Mr(KMnO<sub>4</sub>) =39+55+16*4=158 gr/mol',
            'Mr(MgCl<sub>2</sub>)=24+35,5*2=95gr',
            'm(KMnO<sub>4</sub>)=120gr'],
        solution:['KMnO<sub>4</sub>+HCl→KCl+MnCl<sub>2</sub>+Cl<sub>2</sub>↑+H<sub>2</sub>O'],
        a:'158gr',
        b:'95gr',
        c:'120gr',
        d:'x',
        x:'72,15 gr'

    },
    {
        id:4,
        task:'Massasi 42,5gr natriy nitrati tarqalǵanda qansha gr natriy nitriti payda boladi?',
        desc:['Berilgen:Mr(NaNO<sub>3</sub>) =23+14+16*3=85gr',
            'Mr(NaNO<sub>3</sub>) =23+14+16*3=85gr/mol',
            'Mr(NaNO<sub>2</sub>) =23+14+16*2=69gr/mol',
            'm(NaNO<sub>3</sub>)=42,5gr'
        ],
        solution:['NaNO<sub>3</sub>→NaNO<sub>2</sub>+O<sub>2</sub>↑ '],
        a:'85gr',
        b:'69gr',
        c:'42,5gr',
        d:'x',
        x:'34,5gr'

    },
    {
        id:5,
        task:'Massasi 7,5gr xlorid kislotasi natriy gidroksidi menen reakciyaǵa kiriskende qansha gr duz payda boladi?',
        desc:['Berilgen: Mr(HCl)=1+35,5=36,5gr/mol',
            'Mr(NaCl)=23+35,5=58,5gr/mol',
            'm(HCl)=7,5 gr'],
        solution:['HCl+NaOH→NaCl+H<sub>2</sub>O'],
        a:'36,5gr',
        b:'58,5gr',
        c:'7,5gr',
        d:'x',
        x:'12gr.'

    },
]

export {datas1,datas2,datas3,datas4,datas5,datas6,datas7,datas8,datas9,datas10,datas11,datas15,datas12,datas13,datas14,datas16};
